import { Box, Grid } from "@mui/material";
import { FormSubsection, DisplayField, MUITableD } from "components";
import { useTranslation } from "react-i18next";

type Props = {
  data: any;
};

const Alerts = (props: Props) => {
  const { data } = props;
  const { t } = useTranslation("telemetry"); // Get translation

  const cT = data ? data : {};

  const handleRowClick = () => { };

  const columns = [
    { name: "code", label: t("Code") },
    { name: "status", label: t("Status") },
    { name: "data", label: t("Description") },
  ];

  const modalStyle = {
    position: 'absolute',
    overflow: 'scroll',
    height: '100%',
    display: 'block',
    left: '10%',
    right: '10%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  return (
    <>

      {/* Fixed Header */}
      <Box sx={modalStyle}>
        <FormSubsection title={t("Alerts")}>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <DisplayField
                data={cT}
                name="deviceId"
                label={t("Device ID")}
              />
            </Grid>
            <Grid item xs={4}>
              <DisplayField
                data={cT}
                name="lastSeenAt"
                label={t("Last Seen")}
              />
            </Grid>
            <Grid item xs={4}>
              <DisplayField
                data={cT}
                name="lastErrorEventAt"
                label={t("Last Alert")}
              />
            </Grid>
          </Grid>
        </FormSubsection>

        {data.alerts &&
          data.alerts.length > 0 && (
            <FormSubsection title={t("Alerts")}>
              <MUITableD
                title=""
                data={data.alerts}
                cols={columns}
                sortOrder={{ name: "code", direction: "asc" }}
                onRowClick={handleRowClick}
              />
            </FormSubsection>
          )}
      </Box>

    </>
  );
};

export default Alerts;
